import { OnInit, Component } from '@angular/core';
import {ArticleService} from "../../../core/services/article.service";
import {first} from "rxjs/operators";

@Component({
  selector: 'app-home-testimonials',
  templateUrl: './home-testimonials.component.html',
  styleUrls: ['./home-testimonials.component.scss'],
})
export class HomeTestimonialsComponent implements OnInit {
  currentRate = 5;
  opinionSystemList: any = [];
  rating0: any = 5;
  rating1: any = 5;
  rating2: any = 5;

  constructor(private articleService: ArticleService) {
  }

  ngOnInit(): void {
    this.fetchLastOpinionSystem()
  }

  fetchLastOpinionSystem(){
    this.articleService.fetchLastOpinionSystem()
      .pipe(first()).subscribe(response => {
      if(response.code === 200){
        this.opinionSystemList = response.data.avis;
        // console.log(this.opinionSystemList);
        this.rating0 = ((this.opinionSystemList[0].rating-5)/20) + 1;
        this.rating1 = ((this.opinionSystemList[1].rating-5)/20) + 1;
        this.rating2 = ((this.opinionSystemList[2].rating-5)/20) + 1;
      }

    });
  }
  onNavigateAvis() {
    window.open(
      'https://www.opinionsystem.fr/fr-fr/search/group/2040',
      '_blank',
      'noopener,noreferrer'
    );
  }
}
